<script setup lang="ts">
import { ConnectedAccountsEmbed } from '@/Pejer/tables/ConnectedAccounts'
import { ArrowRight } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from 'pejer/src/components/ui/dialog'
import { ref } from 'vue'
import GeneralUpgrade from './GeneralUpgrade.vue'

const props = defineProps<{
  connectedAccount: ConnectedAccountsEmbed.ListItem
}>()
const emit = defineEmits(['update:close'])

const modalOpen = ref(false)
const closeModal = () => {
  modalOpen.value = false
  emit('update:close')
}
</script>
<template>
  <Dialog v-model:open="modalOpen" @update:open="modalOpen = $event">
    <DialogTrigger as-child>
      <slot>
        <Button
          @click.prevent.stop
          variant="ghost"
          class="p-1 h-6 hover:bg-gray-200 rounded-sm group text-gray-600"
        >
          <ArrowRight class="group-hover:scale-110" :size="16" />
        </Button>
      </slot>
    </DialogTrigger>
    <DialogContent class="w-full max-h-[calc(100vh-50px)] flex flex-col">
      <DialogTitle class="flex-1"> Oppgrader til Direktebetalings-avtale </DialogTitle>
      <DialogDescription class="flex-1">
        Direktebetalings-avtale tillater kunder å kunne betale direkte til bedriftens private konto.
        For å aktivere dette må du følge skrittene under:
      </DialogDescription>
      <div class="flex-1 flex flex-col gap-1 overflow-y-auto">
        <!-- <h3 class="font-semibold">Velg bank</h3>
        <Tabs dropQueryParams default-value="DNB" class="full">
          <TabsList>
            <TabsTrigger value="DNB"> DNB </TabsTrigger>
            <TabsTrigger value="Sparebank1"> Sparebank1 </TabsTrigger>
            <TabsTrigger value="other"> Annen bank </TabsTrigger>
          </TabsList>

          <TabsContent value="DNB"> </TabsContent>
          <TabsContent value="Sparebank1"> </TabsContent>
          <TabsContent value="other"> -->
        <div class="flex flex-col gap-2 mt-4">
          <!-- <span class="italic text-sm mb-2 text-gray-600">
                Stegene under viser en mer generell måter å lage en avtale med banken din på. Du kan
                også søke opp eller kontakte banken for mer spesifikke instruksjoner.
              </span> -->
          <GeneralUpgrade :connected-account="connectedAccount" @update:close="closeModal" />
        </div>
        <!-- </TabsContent>
        </Tabs> -->
      </div>
    </DialogContent>
  </Dialog>
</template>
